import PageHeader from '@/components/page-header';
import RecordForm, { type FieldError } from '@/pages/apps/records/components/record-form';
import type { AppList, AppRecord, AppShell, Customer } from '@/types/platform';

interface RecordsNewProps {
  app: AppShell;
  list: AppList;
  record: AppRecord;
  customers: Customer[];
  errors: string[];
  fieldErrors: FieldError[];
}

const RecordsNew = ({ app, list, record, customers, errors, fieldErrors }: RecordsNewProps) => {
  const takesAttachments = list.fields.some((field) => field.type === 'attachments');

  return (
    <div className="space-y-6">
      <PageHeader title={`New ${list.singular.toLowerCase()}`} description={list.name} />

      <RecordForm
        app={app}
        list={list}
        record={record}
        customers={customers}
        errors={errors}
        fieldErrors={fieldErrors}
      />

      {takesAttachments ? (
        <p className="text-muted-foreground text-sm">Save first, then add photos and files.</p>
      ) : null}
    </div>
  );
};

export default RecordsNew;
